import admin from './view';
import cert from './cert';
import progress from './progress';
import judge from './judge';
import issue from './issue';
import complaint from './complaint';
import statistic from './statistic';
import sales from './sales';
import site from './site';
import user from './user';
import system from './system';

export default [
  {
    path: 'cert',
    component: admin('/cert/template'),
    children: cert,
  },
  {
    path: 'progress',
    component: admin('/progress/template'),
    children: progress,
  },
  {
    path: 'judge',
    component: admin('/judge/template'),
    children: judge,
  },
  {
    path: 'issue',
    component: admin('/issue/template'),
    children: issue,
  },
  {
    path: 'complaint',
    component: admin('/complaint/template'),
    children: complaint,
  },
  {
    path: 'statistic',
    component: admin('/statistic/template'),
    children: statistic,
  },
  {
    path: 'sales',
    component: admin('/sales/template'),
    children: sales,
  },
  {
    path: 'site',
    component: admin('/site/template'),
    children: site,
  },
  {
    path: 'user',
    component: admin('/user/template'),
    children: user,
  },
  {
    path: 'system',
    component: admin('/system/template'),
    children: system,
  },
  {
    path: 'join',
    component: admin('/join/join'),
  },
  {
    path: 'userInfo',
    component: admin('/join/userInfo'),
  },
  {
    path: 'joinComplete',
    component: admin('/join/joinComplete'),
  },
  {
    path: 'login',
    component: admin('/login/login'),
  },
  {
    path: '/',
    component: admin('/redirect'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/index.js